const ButtonCommon = ({ children }) => {
  return (
    <div>
      <a
        className="btn-animated inline-block"
        href="resume.pdf"
        target="_blank"
      >
        <div className="left"></div>
        {children}
        <div className="right"></div>
      </a>
    </div>
  );
};

export default ButtonCommon;
